import { ReactComponent as ReactLogo } from './logo.svg';
import { ReactComponent as RefreshIcon } from './refreshIcon.svg';
import { ReactComponent as CopyIcon } from './copyIcon.svg';
import { useEffect } from 'react';
import { quotes } from './list_of_quotes';

function App() {
	useEffect(() => {
		const quoteField = document.getElementById("quotefield");
		const citeField = document.getElementById("citefield");
		const refreshIcon = document.getElementById("refresh_icon");
		const copyIcon = document.getElementById("copy_icon");
		const grabQuote = () => {
			if (!quoteField.classList.contains("hidden")) {
				quoteField.classList.add("hidden");
			}
			if (!citeField.parentElement.classList.contains("hidden")) {
				citeField.parentElement.classList.add("hidden");
			}

			const randomElement = quotes[Math.floor(Math.random() * quotes.length)];

			quoteField.innerHTML = `<p class="text-lg italic font-medium text-white">${randomElement.quote}</p>`;
			quoteField.classList.remove("hidden");

			if (randomElement.author.length > 0) {
				citeField.innerHTML = `<cite class="pr-3 font-medium text-white">${randomElement.author}</cite>`;
				citeField.parentElement.classList.remove("hidden");
			}
		};

		refreshIcon.addEventListener("click", () => {
			grabQuote();
		});

		copyIcon.addEventListener("click", () => {
			let grabQuoteToCopy = document.querySelector("#quotefield p");
			navigator.clipboard.writeText(grabQuoteToCopy.innerHTML);
		});

		grabQuote();
	}, []);
	return (
		<div className="container mx-auto">
			<ReactLogo />
			<div className="overflow-hidden bg-slate-800 shadow rounded-lg mt-6 lg:w-1/2 md:mx-auto mx-5 px-5 relative">
				<div className="px-4 py-5 sm:p-6">
					<figure className="max-w-screen-md mx-auto text-center">
						<blockquote className="hidden" id="quotefield"></blockquote>
						<figcaption className="flex items-center justify-center mt-6 space-x-3 hidden">
							<div className="flex items-center divide-x-2 divide-gray-700" id="citefield"></div>
						</figcaption>
					</figure>
				</div>
				<RefreshIcon />
				<CopyIcon />
			</div>
		</div>
	);
}

export default App;
